// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { db, auth } from "./Firebase"; // Make sure you export auth from Firebase setup
// import { collection, getDocs, query, where, addDoc, doc, setDoc } from "firebase/firestore";
// import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";

// export default function AuthCard() {
//   const [flipped, setFlipped] = useState(false);
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (localStorage.getItem("username")) {
//       navigate("/");
//     }
//   }, [navigate]);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     const data = new FormData(e.currentTarget);
//     const email = data.get("email");
//     const password = data.get("password");

//     try {
//       const q = query(
//         collection(db, "Users"),
//         where("Email", "==", email),
//         where("Password", "==", password)
//       );
//       const querySnapshot = await getDocs(q);

//       if (!querySnapshot.empty) {
//         const user = querySnapshot.docs[0].data();
//         localStorage.setItem("username", user.uid || user.Email);
//         localStorage.setItem("email", user.Email);
//         localStorage.setItem("fullName", user.Name);

//         if (user.Email === "karanksxxxx@gmail.com") {
//           navigate("/Users");
//         } else {
//           navigate("/");
//         }
//       } else {
//         setError("❌ Wrong email or password.");
//       }
//     } catch (err) {
//       setError(`❌ Error: ${err.message}`);
//     }
//     e.target.reset();
//   };

//   const handleRegister = async (e) => {
//     e.preventDefault();
//     const data = new FormData(e.currentTarget);

//     try {
//       await addDoc(collection(db, "Users"), {
//         Name: data.get("name"),
//         Email: data.get("email"),
//         Contact: data.get("contact"),
//         Gender: data.get("gender"),
//         Password: data.get("password"),
//         Dateofbirth: data.get("dateofbirth"),
//         Address: data.get("address"),
//       });
//       alert("🎉 Registration Successful!");
//       e.target.reset();
//       setFlipped(false);
//     } catch (err) {
//       setError("❌ Registration failed.");
//     }
//   };

//   // Google Sign-In with Firestore data saving
//   const handleGoogleLogin = async () => {
//     const provider = new GoogleAuthProvider();
//     try {
//       const result = await signInWithPopup(auth, provider);
//       const user = result.user;
//       // Check if the user already exists in Firestore
//       const q = query(collection(db, "Users"), where("Email", "==", user.email));
//       const querySnapshot = await getDocs(q);

//       if (querySnapshot.empty) {
//         // If the user doesn't exist, create a new document in Firestore
//         await addDoc(collection(db, "Users"), {
//           Name: user.displayName || "Unknown",
//           Email: user.email,
//           Contact: "Not Provided", // Optionally, set default values
//           Gender: "Not Provided",
//           Password: "Not Set", // We don't need to store a password for Google login
//           Dateofbirth: "Not Provided",
//           Address: "Not Provided",
//         });
//       }

//       // Save user data to localStorage
//       localStorage.setItem("username", user.uid);
//       localStorage.setItem("email", user.email);
//       localStorage.setItem("fullName", user.displayName);

//       // Navigate to the appropriate page
//       if (user.email === "karanksxxxx@gmail.com") {
//         navigate("/Users");
//       } else {
//         navigate("/");
//       }
//     } catch (err) {
//       setError(`❌ Error: ${err.message}`);
//     }
//   };

//   return (
//     <div className="auth">
//       <div className={`auth-card ${flipped ? "flipped" : ""}`}>
//         {/* Front: Login Form */}
//         <div className="front">
//           <center>
//             <img
//               src="logo192.jpeg"
//               width="100px"
//               className="rounded-circle"
//               alt="logo"
//             />
//           </center>
//           <center>
//           <h2>Login</h2>
//           </center>
//           {error && <p className="error">{error}</p>}
//           <form onSubmit={handleLogin}>
//             <input type="email" name="email" placeholder="Email" required />
//             <input
//               type="password"
//               name="password"
//               placeholder="Password"
//               required
//             />
//             <button type="submit">Login</button>
//           </form>
//             <center className="text-warning fw-bold fs-4"> or</center>
//           <button onClick={handleGoogleLogin} className="btn btn text-light">
//           Login with Google  <img src="https://yt3.googleusercontent.com/FJI5Lzbf2dMd32xOqhoKpJArJooZhoX6v2qOcFO-wjSZUvs3H9xqq2gK4DQ47X0KnYgf7X2rpdU=s900-c-k-c0x00ffffff-no-rj" width="50px" className="rounded-circle"/>
//           </button>
//           <p>
//             New user?{" "}
            
//             <span className="link text-light" onClick={() => setFlipped(true)}>
//               Register Here
//             </span>
//           </p>
//         </div>

//         {/* Back: Register Form */}
//         <div className="back">
       
//           <center>
//           <h2>Register</h2>
//           </center>
//           {error && <p className="error">{error}</p>}
//           <form onSubmit={handleRegister}>
//             <input type="text" name="name" placeholder="Name" required />
//             <input type="email" name="email" placeholder="Email" required />
//             <input type="number" name="contact" placeholder="Contact" required />
//             <select name="gender" required>
//               <option value="">Select Gender</option>
//               <option>Male</option>
//               <option>Female</option>
//               <option>Other</option>
//             </select>
//             <input type="password" name="password" placeholder="Password" required />
//             <input type="date" name="dateofbirth" required />
//             <input type="text" name="address" placeholder="Address" required />
//             <button type="submit">Register</button>
//           </form>
//           <p>
//             Already have an account?{" "}
//             <span className="link text-light" onClick={() => setFlipped(false)}>
//               Login
//             </span>
//           </p>
//         </div>
//       </div>

//       {/* Styling */}
//       <style jsx>{`
//         .auth {
//           display: flex;
//           align-items: center;
//           height: 100vh;
//           background-image: url(https://static.vecteezy.com/system/resources/thumbnails/037/236/347/small_2x/ai-generated-bakery-advertisment-background-with-copy-space-free-photo.jpg);
//           background-size: cover;
//           overflow: hidden;
//         }

//         .auth-card {
//           width: 380px;
//           height: 520px;
//           perspective: 1000px;
//           align-items: center;
//           margin: 0 auto;
//         }

//         .auth-card > div {
//           background: transparent;
//           border-radius: 10px;
//           border: 1px white solid;
//           padding: 20px;
//           box-shadow: 0 20px 40px rgb(0, 0, 0);
//           position: absolute;
//           width: 100%;
//           backface-visibility: hidden;
//           transition: transform 0.6s;
//         }

//         .auth-card .front {
//           transform: rotateY(0deg);
//         }

//         .auth-card .back {
//           transform: rotateY(180deg);
//         }

//         .auth-card.flipped .front {
//           transform: rotateY(-180deg);
//         }

//         .auth-card.flipped .back {
//           transform: rotateY(0deg);
//         }

//         input,
//         select {
//           width: 100%;
//           margin: 8px 0;
//           padding: 10px;
//           font-size: 16px;
//           border: 1px solid #ccc;
//           border-radius: 5px;
//         }

//         button {
//           width: 100%;
//           padding: 10px;
//           background: #4e73df;
//           color: white;
//           font-weight: bold;
//           border: none;
//           border-radius: 5px;
//           cursor: pointer;
//         }

//         .google-btn {
//           width: 100%;
//           padding: 10px;
//           background: #db4437;
//           color: white;
//           font-weight: bold;
//           border: none;
//           border-radius: 5px;
//           cursor: pointer;
//           margin-top: 10px;
//         }
//         .google-btn:hover {
//           background: #c1351d;
//         }

//         .link {
//           color: #4e73df;
//           cursor: pointer;
//           text-decoration: underline;
//         }

//         .error {
//           color: red;
//         }
//       `}</style>
//     </div>
//   );
// }



import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db, auth } from "./Firebase";
import {
  collection,
  getDocs,
  query,
  where,
  addDoc
} from "firebase/firestore";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import emailjs from "@emailjs/browser";

export default function AuthCard() {
  const [flipped, setFlipped] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("username")) {
      navigate("/");
    }
  }, [navigate]);

  // ✅ Send Login Notification
  const sendLoginEmail = (email, name) => {
    emailjs.send(
      "service_nn606kn",       // Replace with your EmailJS service ID
      "template_8i8t5yc",      // Replace with your EmailJS template ID
      {
        user_email: email,
        user_name: name,
      },
      "CVy20pZ0JQ_XxmyCq"        // Replace with your EmailJS public key
    ).then(
      (response) => {
        console.log("✅ Email sent!", response.status, response.text);
      },
      (error) => {
        console.error("❌ Email sending failed:", error);
      }
    );
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const email = data.get("email");
    const password = data.get("password");

    try {
      const q = query(
        collection(db, "Users"),
        where("Email", "==", email),
        where("Password", "==", password)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const user = querySnapshot.docs[0].data();
        localStorage.setItem("username", user.uid || user.Email);
        localStorage.setItem("email", user.Email);
        localStorage.setItem("fullName", user.Name);

        // ✅ Send login notification
        sendLoginEmail(user.Email, user.Name);

        if (user.Email === "karanksxxxx@gmail.com") {
          navigate("/Users");
        } else {
          navigate("/");
        }
      } else {
        setError("❌ Wrong email or password.");
      }
    } catch (err) {
      setError(`❌ Error: ${err.message}`);
    }
    e.target.reset();
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);

    try {
      await addDoc(collection(db, "Users"), {
        Name: data.get("name"),
        Email: data.get("email"),
        Contact: data.get("contact"),
        Gender: data.get("gender"),
        Password: data.get("password"),
        Dateofbirth: data.get("dateofbirth"),
        Address: data.get("address"),
      });
      alert("🎉 Registration Successful!");
      e.target.reset();
      setFlipped(false);
    } catch (err) {
      setError("❌ Registration failed.");
    }
  };

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const q = query(collection(db, "Users"), where("Email", "==", user.email));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        await addDoc(collection(db, "Users"), {
          Name: user.displayName || "Unknown",
          Email: user.email,
          Contact: "Not Provided",
          Gender: "Not Provided",
          Password: "Not Set",
          Dateofbirth: "Not Provided",
          Address: "Not Provided",
        });
      }

      localStorage.setItem("username", user.uid);
      localStorage.setItem("email", user.email);
      localStorage.setItem("fullName", user.displayName);

      // ✅ Send login notification
      sendLoginEmail(user.email, user.displayName);

      if (user.email === "karanksxxxx@gmail.com") {
        navigate("/Users");
      } else {
        navigate("/");
      }
    } catch (err) {
      setError(`❌ Error: ${err.message}`);
    }
  };

  return (
    <div className="auth">
      <div className={`auth-card ${flipped ? "flipped" : ""}`}>
        {/* Front: Login Form */}
        <div className="front">
          <center>
            <img src="logo192.jpeg" width="100px" className="rounded-circle" alt="logo" />
          </center>
          <center><h2>Login</h2></center>
          {error && <p className="error">{error}</p>}
          <form onSubmit={handleLogin}>
            <input type="email" name="email" placeholder="Email" required />
            <input type="password" name="password" placeholder="Password" required />
            <button type="submit">Login</button>
          </form>
          <center className="text-warning fw-bold fs-4">or</center>
          <button onClick={handleGoogleLogin} className="btn btn text-light">
            Login with Google <img src="https://yt3.googleusercontent.com/FJI5Lzbf2dMd32xOqhoKpJArJooZhoX6v2qOcFO-wjSZUvs3H9xqq2gK4DQ47X0KnYgf7X2rpdU=s900-c-k-c0x00ffffff-no-rj" width="50px" className="rounded-circle" alt="google" />
          </button>
          <p>
            New user? <span className="link text-light" onClick={() => setFlipped(true)}>Register Here</span>
          </p>
        </div>

        {/* Back: Register Form */}
        <div className="back">
          <center><h2>Register</h2></center>
          {error && <p className="error">{error}</p>}
          <form onSubmit={handleRegister}>
            <input type="text" name="name" placeholder="Name" required />
            <input type="email" name="email" placeholder="Email" required />
            <input type="number" name="contact" placeholder="Contact" required />
            <select name="gender" required>
              <option value="">Select Gender</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
            <input type="password" name="password" placeholder="Password" required />
            <input type="date" name="dateofbirth" required />
            <input type="text" name="address" placeholder="Address" required />
            <button type="submit">Register</button>
          </form>
          <p>
            Already have an account? <span className="link text-light" onClick={() => setFlipped(false)}>Login</span>
          </p>
        </div>
      </div>

      {/* Inline Styling */}
      <style jsx>{`
        .auth {
          display: flex;
          align-items: center;
          height: 100vh;
          background-image: url(https://static.vecteezy.com/system/resources/thumbnails/037/236/347/small_2x/ai-generated-bakery-advertisment-background-with-copy-space-free-photo.jpg);
          background-size: cover;
          overflow: hidden;
        }

        .auth-card {
          width: 380px;
          height: 520px;
          perspective: 1000px;
          margin: 0 auto;
        }

        .auth-card > div {
          background: transparent;
          border-radius: 10px;
          border: 1px white solid;
          padding: 20px;
          box-shadow: 0 20px 40px rgb(0, 0, 0);
          position: absolute;
          width: 100%;
          backface-visibility: hidden;
          transition: transform 0.6s;
        }

        .auth-card .front {
          transform: rotateY(0deg);
        }

        .auth-card .back {
          transform: rotateY(180deg);
        }

        .auth-card.flipped .front {
          transform: rotateY(-180deg);
        }

        .auth-card.flipped .back {
          transform: rotateY(0deg);
        }

        input,
        select {
          width: 100%;
          margin: 8px 0;
          padding: 10px;
          font-size: 16px;
          border: 1px solid #ccc;
          border-radius: 5px;
        }

        button {
          width: 100%;
          padding: 10px;
          background: #4e73df;
          color: white;
          font-weight: bold;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        .link {
          color: #4e73df;
          cursor: pointer;
          text-decoration: underline;
        }

        .error {
          color: red;
        }
      `}</style>
    </div>
  );
}
